import * as React from 'react'
import { EditorContainer } from './EditorContainer'

import { Comment as IComment } from '../dtos'

export interface FooterProps {
    conversationId: string
    getTributeComponent: any
    goToComment?: (id: string) => void
    user: { id: string }
    addComment: (comment: IComment, callback?: () => void) => void
    tributes?: Array<any>
}

export const Footer: React.FC<FooterProps> = (props) => {
    return (
        <EditorContainer
            initialValue={''}
            getTributeComponent={props.getTributeComponent}
            goToComment={props.goToComment}
            parentConversation={{ id: props.conversationId }}
            editorType={'default'}
            user={props.user}
            onAddComment={props.addComment}
            // @ts-ignore
            submitting={undefined}
            // @ts-ignore
            comment={undefined}
            tributes={props.tributes}
        />
    )
}
